import { getBranding } from 'app/configs/whitelabelConfig';
import { createContext, useContext, useEffect } from 'react';

const BrandingContext = createContext(null);

export function BrandingProvider({ children }) {
  const branding = getBranding();

  useEffect(() => {
    let link = document.querySelector("link[rel='icon']");
    let title = document.querySelector('title');
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';

      document.head.appendChild(link);
    }
    if (!title) {
      title = document.createElement('title');
      document.head.appendChild(title);
    }
    link.href = branding.favicon;
    title.innerText = branding.pageTitle;
  }, [branding.pageTitle, branding.favicon]);

  return (
    <BrandingContext.Provider value={branding}>
      {children}
    </BrandingContext.Provider>
  );
}

export function useBranding() {
  return useContext(BrandingContext);
}
